import { SocieteFormeJuridique } from './societe-forme-juridique';

export class LowInfoContact {
  public id: number;
  public nom?: string;
  public prenom?: string;
  public societeFormeJuridique: SocieteFormeJuridique;
  public tva?: string;
  public typeSociete?: boolean;
  public flagDelete?: string;
}
